<div class="swagger-auth-body">
  <div class="login-container">
    <div class="logo">
      @if (logoUrl) {
      <img [src]="logoUrl" [alt]="platformName + ' Logo'" class="platform-logo" />
      }
      <h1>{{ platformName }}</h1>
      <p>{{ subtitle }}</p>
    </div>

    @if (errorMessage()) {
    <div class="error-message" id="errorMessage">
      {{ errorMessage() }}
    </div>
    }

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" id="loginForm" autocomplete="on">
      <div class="form-group">
        <label for="tenancyName">Tenancy Name (Optional)</label>
        <input
          type="text"
          id="tenancyName"
          formControlName="tenancyName"
          maxlength="100"
          autocomplete="organization"
          [class.error]="hasFieldError('tenancyName')" />
        @if (hasFieldError('tenancyName')) {
        <div class="field-error">
          {{ getFieldError("tenancyName") }}
        </div>
        }
      </div>

      <div class="form-group">
        <label for="username">Username or Email</label>
        <input
          #usernameInput
          type="text"
          id="username"
          formControlName="username"
          required
          maxlength="254"
          autocomplete="username"
          [class.error]="hasFieldError('username')" />
        @if (hasFieldError('username')) {
        <div class="field-error">
          {{ getFieldError("username") }}
        </div>
        }
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input
          #passwordInput
          type="password"
          id="password"
          formControlName="password"
          required
          maxlength="128"
          autocomplete="current-password"
          [class.error]="hasFieldError('password')" />
        @if (hasFieldError('password')) {
        <div class="field-error">
          {{ getFieldError("password") }}
        </div>
        }
      </div>

      <button type="submit" class="login-btn" id="loginBtn" [disabled]="isLoading()">
        Access Swagger Documentation
      </button>
    </form>

    @if (isLoading()) {
    <div class="loading" id="loading">Authenticating...</div>
    }
  </div>

  <div class="footer">
    <p>&copy; {{ getCurrentYear() }} {{ companyName }}. All rights reserved.</p>
  </div>
</div>
